export type Store = {
    id: number,
    name: string,
    postcode: string,
    date: Date,
};

export type Marker = {
    stores: Store[],
    position: [number, number],
};

export const markers: Marker[] = [
    {
        position: [175, 315],
        stores: [
            {
                id: 2050,
                name: 'Baguley Extra',
                postcode: 'M23 9TJ',
                date: new Date(2021, 10, 5),
            },
            {
                id: 5851,
                name: 'Hanley Extra',
                postcode: 'ST1 4AA',
                date: new Date(2021, 10, 6),
            },
        ],
    },
    {
        position: [170, 350],
        stores: [
            {
                id: 3398,
                name: 'Stafford Extra',
                postcode: 'ST16 2HE',
                date: new Date(2021, 10, 7),
            },
            {
                id: 3290,
                name: 'Telford Extra',
                postcode: 'TF1 2DE',
                date: new Date(2021, 10, 8),
            },
            {
                id: 6197,
                name: 'Dudley Extra',
                postcode: 'DY1 4RP',
                date: new Date(2021, 10, 9),
            },
        ],
    },
    {
        position: [182, 380],
        stores: [
            {
                id: 5168,
                name: 'Coventry Crosspt Ext',
                postcode: 'CV2 2SH',
                date: new Date(2021, 10, 10),
            },
            {
                id: 3370,
                name: 'Warwick',
                postcode: 'CV34 5QJ',
                date: new Date(2021, 10, 11),
            },
            {
                id: 2064,
                name: 'Banbury Extra',
                postcode: 'OX16 1LX',
                date: new Date(2021, 10, 12),
            },
        ],
    },
    {
        position: [158, 422],
        stores: [
            {
                id: 2141,
                name: 'Brislington Extra',
                postcode: 'BS4 5AY',
                date: new Date(2021, 10, 15),
            },
            {
                id: 2136,
                name: 'Bristol East Extra',
                postcode: 'BS5 6XU',
                date: new Date(2021, 10, 16),
            },
            {
                id: 2880,
                name: 'Midsomer Norton',
                postcode: 'BS39 7SW',
                date: new Date(2021, 10, 17),
            },
        ],
    },
    {
        position: [188, 432],
        stores: [
            {
                id: 2919,
                name: 'Newbury Extra',
                postcode: 'RG14 7HB',
                date: new Date(2021, 10, 14),
            },
        ],
    },
    {
        position: [206, 415],
        stores: [
            {
                id: 2038,
                name: 'Aylesbury Extra',
                postcode: 'HP19 8BU',
                date: new Date(2021, 10, 13),
            },
            {
                id: 3095,
                name: 'Reading Extra',
                postcode: 'RG1 8DF',
                date: new Date(2021, 10, 29),
            },
            {
                id: 5528,
                name: 'Reading West Extra',
                postcode: 'RG30 1AH',
                date: new Date(2021, 10, 30),
            },
            {
                id: 2020,
                name: 'Amersham',
                postcode: 'HP7 0HA',
                date: new Date(2021, 11, 6),
            },
        ],
    },
    {
        position: [225, 430],
        stores: [
            {
                id: 2934,
                name: 'New Malden Extra',
                postcode: 'KT3 4PJ',
                date: new Date(2021, 11, 1),
            },
            {
                id: 3220,
                name: 'Sunbury Extra',
                postcode: 'TW16 7BB',
                date: new Date(2021, 11, 2),
            },
            {
                id: 3324,
                name: 'Twickenham Extra',
                postcode: 'TW7 7JY',
                date: new Date(2021, 11, 3),
            },
            {
                id: 2128,
                name: 'Osterley Extra',
                postcode: 'TW7 5NZ',
                date: new Date(2021, 11, 4),
            },
            {
                id: 2586,
                name: 'Hoover Building',
                postcode: 'UB6 8DW',
                date: new Date(2021, 11, 5),
            },
            {
                id: 3372,
                name: 'Watford Extra',
                postcode: 'WD17 2BD',
                date: new Date(2021, 11, 7),
            },
            {
                id: 2296,
                name: 'Colney Hatch Extra',
                postcode: 'N12 0SH',
                date: new Date(2021, 11, 8),
            },
            {
                id: 3333,
                name: 'Lea Valley Extra',
                postcode: 'N18 3HF',
                date: new Date(2021, 11, 9),
            },
            {
                id: 2569,
                name: 'Goodmatrading Extra',
                postcode: 'RM6 4HY',
                date: new Date(2021, 11, 10),
            },
            {
                id: 3086,
                name: 'Rainham Essex Extra',
                postcode: 'RM13 9YZ',
                date: new Date(2021, 11, 11),
            },
        ],
    },
    {
        position: [250, 424],
        stores: [
            {
                id: 3060,
                name: 'Pitsea Extra',
                postcode: 'SS13 3JU',
                date: new Date(2021, 11, 12),
            },
            {
                id: 2073,
                name: 'Basildon Extra',
                postcode: 'SS14 3HZ',
                date: new Date(2021, 11, 13),
            },
            {
                id: 2330,
                name: 'Chelmsford 2',
                postcode: 'CM2 9XW',
                date: new Date(2021, 11, 14),
            },
            {
                id: 2882,
                name: 'Maldon Extra',
                postcode: 'CM9 4LE',
                date: new Date(2021, 11, 15),
            },
        ],
    },
    {
        position: [275, 408],
        stores: [
            {
                id: 2326,
                name: 'Colchester Extra',
                postcode: 'CO4 9ED',
                date: new Date(2021, 11, 16),
            },
            {
                id: 2748,
                name: 'Ipswich Extra',
                postcode: 'IP8 3TS',
                date: new Date(2021, 11, 17),
            },

            {
                id: 2877,
                name: 'Martlesham Extra',
                postcode: 'IP5 3RU',
                date: new Date(2021, 11, 18),
            },

        ],
    },
    {
        position: [175, 465],
        stores: [
            {
                id: 3133,
                name: 'Salisbury 2 Extra',
                postcode: 'SP1 2NY',
                date: new Date(2021, 10, 18),
            },
            {
                id: 3036,
                name: 'Poole Extra',
                postcode: 'BH12 4NX',
                date: new Date(2021, 10, 19),
            },
            {
                id: 3040,
                name: 'Poole Fleets Cnr Ext',
                postcode: 'BH17 7EJ',
                date: new Date(2021, 10, 20),
            },
            {
                id: 2156,
                name: 'Bursledon Twrs Extra',
                postcode: 'SO31 8GN',
                date: new Date(2021, 10, 21),
            },
            {
                id: 3055,
                name: 'Portsmouth Extra',
                postcode: 'PO6 4SR',
                date: new Date(2021, 10, 22),
            },
        ],
    },
    {
        position: [210, 465],
        stores: [
            {
                id: 2266,
                name: 'Chichester Extra',
                postcode: 'PO19 3JT',
                date: new Date(2021, 10, 23),
            },
            {
                id: 6056,
                name: 'West Durrington Extra',
                postcode: 'BN13 3PB',
                date: new Date(2021, 10, 24),
            },

        ],
    },
];
